<div class="category-container">
    <div class="loaded-container" *ngIf="isDataLoaded">
        <div class="details-container">
            <div class="details-field-wrapper">
                <app-widget-textbox [model]="category?.description" (modelChange)="onMainCategoryNameChange($event)"
                    title="{{ 'translation:Name' | i18next }}" textboxWidth="250px"></app-widget-textbox>
            </div>
            <!-- <div class="details-field-wrapper">
                <app-widget-textbox [model]="category.context" (modelChange)="category.context=$event"
                    title="{{ 'translation:Context' | i18next }}" textboxWidth="400px"></app-widget-textbox>
            </div> -->
            <div class="details-field-wrapper">
                <div class="main-selection-type">{{ 'translation:Selection type' | i18next }}</div>
                <ng-select [items]="selectionType" bindLabel="text" bindValue="key" class="" [searchable]="false"
                    [(ngModel)]="selectionTypeChoice" (change)="changeMainSelectionType($event)"
                    [ngStyle]="{width:'150px'}">
                </ng-select>
            </div>
            <div class="details-field-wrapper">
                <div class="global-settings-text">
                    {{ 'translation:Category type' | i18next }}
                </div>
                <mat-radio-group aria-label="Select an option">
                    <mat-radio-button (click)="onGlobalSettingsChange($event, 'Ordinary')"
                        [checked]="!category?.isDefault && !category?.isOutbound" value="1">{{ 'translation:Ordinary' |
                        i18next }}</mat-radio-button>
                    <mat-radio-button (click)="onGlobalSettingsChange($event, 'Default')"
                        [checked]="category?.isDefault && category?.isOutbound ? false : category?.isDefault"
                        value="2">Default</mat-radio-button>
                    <mat-radio-button (click)="onGlobalSettingsChange($event, 'Dialler')"
                        [checked]="category?.isDefault && category?.isOutbound ? true : category?.isOutbound"
                        value="3">{{
                        'translation:Reserved for Dialler' | i18next }}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="details-field-wrapper">
                <div class="main-selection-type">{{ 'translation:Forced for agents' | i18next }}</div>
                <ng-select [items]="forcedForAgentsChoice" bindLabel="text" bindValue="key" class=""
                    [searchable]="false" [(ngModel)]="isForced" (change)="changeForcedForAgents($event)"
                    [ngStyle]="{width:'200px'}">
                </ng-select>
            </div>
            <div class="details-field-wrapper">
                <button [ngClass]="['primary-button', 'expand-collapse-btn']" *ngIf="isExpanded" matButton
                    (click)="toggleCollapse()">{{
                    'translation:Collapse all' | i18next }}</button>
                <button [ngClass]="['primary-button', 'expand-collapse-btn']" *ngIf="!isExpanded" matButton
                    (click)="toggleExpand()">{{
                    'translation:Expand all' | i18next }}</button>
            </div>
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList (cdkDropListDropped)="drop($event)">
            <!-- add cdkDrag back -->
            <mat-tree-node *matTreeNodeDef="let node" cdkDrag matTreeNodeToggle matTreeNodePadding [cdkDragData]="node"
                (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                (cdkDragReleased)="dragEnd()">
                <i *ngIf="node.level !== 0" class="far fa-level-up-alt fa-rotate-90 fa-lg" style="color: #623875"></i>
                <i *ngIf="node.level !== 0" cdkDragHandle class="fal fa-bars drag-handle"></i>
                <button mat-icon-button disabled></button>
                <div [ngClass]="node.level === 0 ? 'main-node-information' : 'node-information'">
                    <div class="node-description">
                        {{node.description}}
                    </div>
                    <div class="node-actions">
                        <span *ngIf="node.isSensitive === 1" class="sensitive">Sensitive</span>
                        <span *ngIf="node.storageTime && hasUnleashAccess" class="storage-time">{{ node.storageTime }}</span>
                        <i *ngIf="node.level < 5" [ngClass]="['fal fa-plus-circle fa-lg', 'add-icon']"
                            (click)="addNewNode(node)"></i>
                        <i *ngIf="node.level !== 0" [ngClass]="['fal fa-trash-alt', 'delete-icon']"
                            (click)="deleteNode(node)"></i>
                        <i *ngIf="node.level !== 0" [ngClass]="['fal fa-pencil fa-lg', 'edit-icon']"
                            (click)="editNode(node)"></i>
                    </div>
                </div>

            </mat-tree-node>

            <!-- add cdkDrag back -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" cdkDrag matTreeNodePadding [cdkDragData]="node"
                (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                (cdkDragReleased)="dragEnd()">
                <i *ngIf="node.level !== 0" class="far fa-level-up-alt fa-rotate-90 fa-lg" style="color: #623875"></i>
                <i *ngIf="node.level !== 0" cdkDragHandle class="fal fa-bars drag-handle"></i>
                <i *ngIf="node.level == 0" cdkDragHandle class="fal fa-bars drag-handle-main"></i>
                <button *ngIf="node.level !== 0" mat-icon-button matTreeNodeToggle
                    (click)="expansionModel.toggle(node.externalId.toString())"
                    [attr.aria-label]="'toggle ' + node.filename">
                    <i [matTooltip]="treeControl.isExpanded(node) ? 'Collapse' : 'Expand'" matTooltipClass="tooltip"
                        [ngClass]="treeControl.isExpanded(node) ? 'fas fa-minus-circle fa-lg' : 'fas fa-plus-circle fa-lg'"></i>
                </button>
                <div [ngClass]="node.level === 0 ? 'main-node-information' : 'node-information'">
                    <div class="node-description">
                        {{node.description}}
                    </div>
                    <div class="node-actions">
                        <ng-select *ngIf="node.level !== 0" [items]="selectionType" bindLabel="text" bindValue="key"
                            class="node-select" [searchable]="false" [(ngModel)]="node.isMultiSelect"
                            (change)="changeNodeSelectionType(node)" [ngStyle]="{width:'150px'}">
                        </ng-select>
                        <i [ngClass]="['fal fa-plus-circle fa-lg', 'add-icon']" (click)="addNewNode(node)"></i>
                        <i *ngIf="node.level !== 0" [ngClass]="['fal fa-trash-alt', 'delete-icon']"
                            (click)="deleteNode(node)"></i>
                        <i *ngIf="node.level !== 0" [ngClass]="['fal fa-pencil fa-lg', 'edit-icon']"
                            (click)="editNode(node)"></i>
                    </div>
                </div>
            </mat-tree-node>

        </mat-tree>
        <div class="buttons-container">
            <button matButton [disabled]="isSaveDisabled" [ngClass]="['secondary-button', 'cancel-button']"
                (click)="undoChanges()">{{ 'Undo changes' | i18next
                }}</button>
            <button matButton [disabled]="isSaveDisabled" [ngClass]="['primary-button']" (click)="saveChanges()">{{
                'Save' |
                i18next
                }}</button>
        </div>
    </div>

    <div *ngIf="!isDataLoaded" class="data-loading">
        <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
        <span>{{ 'dashboard:Loading' | i18next }}...</span>
    </div>
</div>